import { render, staticRenderFns } from "./LocalPdf.vue?vue&type=template&id=726612a0&"
import script from "./LocalPdf.vue?vue&type=script&lang=js&"
export * from "./LocalPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports